// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"165":"stencil-h8k-logo_2-entry-js","234":"stencil-polyfills-core-js","386":"stencil-polyfills-css-shim","465":"stencil-polyfills-dom"}[chunkId] + "." + {"165":"5d133f9b","234":"384ce261","386":"e6012ff5","465":"f8150a5e"}[chunkId] + ".chunk.js";
};